import { Clock, Brain, SkipForward, CheckCircle } from 'lucide-react';

interface GameStatsProps {
  stats: {
    viewed: number;
    skipped: number;
    total: number;
  };
  questionsInCurrentSession: number;
  questionsPerMinute: number;
  isTimerRunning: boolean;
}

export const GameStats: React.FC<GameStatsProps> = ({
  stats,
  questionsInCurrentSession,
  questionsPerMinute,
  isTimerRunning,
}) => {
  return (
    <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
      <StatCard
        icon={<CheckCircle className="w-4 h-4 text-blue-600 dark:text-blue-400" />}
        title="Questions Viewed"
        value={stats.viewed}
        theme="blue"
      />
      <StatCard
        icon={<SkipForward className="w-4 h-4 text-yellow-600 dark:text-yellow-400" />}
        title="Skipped"
        value={stats.skipped}
        theme="yellow"
      />
      <StatCard
        icon={<Brain className="w-4 h-4 text-green-600 dark:text-green-400" />}
        title="Current Session"
        value={questionsInCurrentSession}
        theme="green"
      />
      <StatCard
        icon={<Clock className="w-4 h-4 text-purple-600 dark:text-purple-400" />}
        title="Questions/min"
        value={isTimerRunning ? questionsPerMinute : '-'}
        theme="purple"
      />
    </div>
  );
};

interface StatCardProps {
  icon: React.ReactNode;
  title: string;
  value: number | string;
  theme: 'blue' | 'yellow' | 'green' | 'purple';
}

const StatCard: React.FC<StatCardProps> = ({ icon, title, value, theme }) => {
  const themeStyles = {
    blue: 'from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 border-blue-200 dark:border-blue-800',
    yellow: 'from-yellow-50 to-yellow-100 dark:from-yellow-900/20 dark:to-yellow-800/20 border-yellow-200 dark:border-yellow-800',
    green: 'from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20 border-green-200 dark:border-green-800',
    purple: 'from-purple-50 to-purple-100 dark:from-purple-900/20 dark:to-purple-800/20 border-purple-200 dark:border-purple-800',
  };

  return (
    <div className={`bg-gradient-to-br ${themeStyles[theme]} p-4 rounded-lg border transition-colors duration-200`}>
      <h4 className="font-semibold text-gray-700 dark:text-gray-200 flex items-center gap-2">
        {icon}
        {title}
      </h4>
      <p className="text-2xl font-bold text-gray-800 dark:text-gray-100">{value}</p>
    </div>
  );
};